'use client';

import useCart from '@/lib/hooks/use-cart';
import Button from '@/components/button';
import { Box } from '~/components/layout/box';
import { track } from '@vercel/analytics';

export default function BundleAddToCart({ books }: { books: any[] }) {
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    track('mbs_add_to_cart');
    books.forEach((book) => {
      addToCart({ item: book, source: 'bundle-search' });
    });
  };

  return (
    <Box style={{ width: '100%' }}>
      <Button text="Add Bundle to Cart" onPress={handleAddToCart} />
    </Box>
  );
}
